module.exports = __webpack_public_path__ + "assets/img/loding.bacd6fe9.gif";